module.exports = __webpack_public_path__ + "img/bizsolutions-tn.dcd30991.jpg";